import updateVariantInfo from 'UTILS/forms/updateVariantInfo';

const product = {
  init: () => {
    document.addEventListener('variantChanged', updateVariantInfo);

    $('.custom-variant-quantity-selector select').prettyDropdown({
      height: 45,
      customClass: 'arrow wyld-select',
      width: 246,
    });
  },
};

product.init();
